import {
    closeReportsGenerator,
    hideReportsGenerator,
    openReportsGenerator,
    showAnalyticsFeaturePopover,
    onRunChart
} from './actions';
import {isMenuItemWithFeaturePromotion} from './consts';

export function publishReportsGenerator() {
    window['reportsGenerator'] = {};
    window['reportsGenerator']['openReportsGenerator'] = openReportsGenerator;
    window['reportsGenerator']['closeReportsGenerator'] = closeReportsGenerator;
    window['reportsGenerator']['hideReportsGenerator'] = hideReportsGenerator;
    window['reportsGenerator']['showAnalyticsFeaturePopover'] = showAnalyticsFeaturePopover;
    window['reportsGenerator']['isMenuItemWithFeaturePromotion'] = isMenuItemWithFeaturePromotion;
    window['reportsGenerator']['onRunChart'] = onRunChart;
}
